const TRANSLATION = {
  buyModal: {
    afterFree: 'Vapaaseen kokeiluajalleesi jälkeen',
    btn: 'Kokeile ilmaiseksi',
    freeTrial: '3 päivän ilmainen kokeilu',
    monthLabel: 'kuukausi',
    selectLabel: 'Valitse suunnitelma',
    title: 'Tilaussuunnitelma',
    yearLabel: 'vuosi',
  },
  contact: {
    block1:
      'Mukauttamiseen, kysymyksiin tai ehdotuksiin ota yhteyttä meihin osoitteeseen contact@noam.tools. Vastaanamme nopeasti.',
    block2:
      'Tuenna meitä antamalla meille arvostelu Google Apps Extension -kaupassa tähtimerkillä ★★★★★.',
    block3: 'Auta muita jakamalla tämä laajennus:',
    title: 'Ota yhteyttä',
  },
  help: {
    AquickOverviewOfNoam: 'Noamin nopea yhteenveto',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Suosikkien hallinta',
    Fixedplugin: 'Korjattu plugin',
    Focusing: 'Fokusointi',
    Free: 'Vapaa',
    FreeTrialBenefits: 'Ilmaisen kokeilun edut',
    GoWithWikipedia: 'Käytä Wikipediaa',
    GoWithYouTube: 'Käytä YouTubea',
    HoverTranslation: 'Hiirenkursorin käännös',
    Howtouse: 'Käyttöohjeet',
    ImageTranslation: 'KuvaKäännös',
    InstantTranslation: 'Noutovastauskäännös',
    Membership: 'Jäsenyys',
    NoamHelp: 'Noam auttaa sinua kääntämään ja yhteenvetämään',
    PDFparallelTranslation: 'PDF:n rinnakkaistranslaatio',
    ParallelTranslation: 'Rinnakkaistranslaatio',
    SkipAllSteps: 'Ohita kaikki vaiheet',
    Summary: 'Yhteenveto',
    Translation: 'Käännös',
    TryItForFree: 'Kokeile ilmaiseksi',
    Video: 'Video',
    VideoSummary: 'Videon yhteenveto',
    VideoTranslation: 'Videon kääntäminen',
    WebSummary: 'Verkkoyhteenveto',
    WordSelectionTranslation: 'Sanavalinnan kääntäminen',
    benefits: 'Meillä on sinua odottavia etuja!',
    dayFree: '3 päivän ilmainen kokeilu',
    done: 'Valmis',
    next: 'Seuraava',
    pin: 'Pinnaa Noam helpompaa käyttöä varten～～',
    planIsNotExist: 'Suunnitelma ei ole saatavilla',
    startWiki: 'Aloitetaan Wikimediaista!',
    startYoutube: 'Aloitetaan YouTubesta!',
    try: 'Kokeile sitä',
    tryNow: 'Kokeilepa nyt!',
  },
  home: {
    PDFTranslate: {
      desc: 'Kaksikielinen kääntäminen + Chat PDF',
      sub1: {
        desc: 'Kaksikielinen lukeminen mahdollistaa alkuperäisen tekstin ja käännöksen rinnakkain vertaamisen, mikä parantaa luketehokkuutta.',
        title: 'Kaksikielinen lukeminen',
      },
      sub2: {
        desc: 'AI analysoi ja yhteenvetää tietoja sekä voi vastata kysymyksiisi PDF:n sisällön perusteella.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'AI:lla tehostettu PDF-käännös suuremman tarkkuuden ja tehokkuuden saavuttamiseksi.',
        title: 'Tarkkuus ja tehokkuus',
      },
      title: 'PDF:n kääntäminen',
    },
    aiAssistant: {
      desc: 'Verkkösuomentamisen tehostaminen ja helpottaminen',
      panel1: {
        desc: 'Kaksikieliset rinnakkaissuunnitelmat auttavat sinua vertailemaan alkuperäistekstiä käännöstä, jotta voit ymmärtää paremmin ja parantaa lukutehokkuuttasi.',
        title: 'Kaksikielinen kääntäminen',
      },
      panel2: {
        left: {
          desc: 'Selaillaessa verkkosivua vie hiiren osoitin haluamasi kääntää olevan sisällön päälle nähdäksesi käännöksen.',
          title: 'Hover-käännös',
        },
        right: {
          desc: 'Selaillessasi verkkosivua valitse tekstiä, jonka haluat kääntää, jotta näet käännöksen.',
          title: 'Tekstin valinnan kääntäminen',
        },
      },
      panel3: {
        one: {
          desc: 'Käännä ja yhteenvetää verkkosivuja ja videosisältöä milloin tahansa, missä tahansa – jotta käyttökokemus olisi sujuvempi!',
          title: 'Piste ja napsauta',
        },
        three: {
          desc: 'AI-ohjattu suuri kielimalli varmistaa käännösten tarkkuuden ja yhtenäisyyden parannetun lukemiskokemuksen saavuttamiseksi.',
          title: 'AI-ohjattu',
        },
        two: {
          desc: 'Monikielinen täydellinen coverage, kaksikielinen esteetön lukeminen, yhdellä napsautuksella suomennos – kokeile eroa!',
          title: 'Yksityiskohtaisempi ja helpompi',
        },
      },
      panel4: {
        tab1: {
          desc: 'Tehokkuusasiantuntijasi – Noam käyttää ChatGPT:tä suomentamaan ja yhteenvetämään YouTube-videoita, jotta säästät aikaa!',
          key: 'Video',
          title: 'Videon kääntäminen ja yhteenveto',
        },
        tab2: {
          desc: 'Klikkaa kuvien kääntämiseen selatessa verkkoa.',
          key: 'Kuva',
          title: 'Kuvan kääntäminen',
        },
        tab3: {
          desc: 'Etsii nopeasti avainsanat verkkosivuilta ja luo yhteenveton, mikä parantaa lukemiseesi tehokkuutta.',
          key: 'Web',
          title: 'Web-käännös ja yhteenveto',
        },
        tag1: 'Yksinkertainen',
        tag2: 'tehokas',
        tag3: 'Helposti ymmärrettävä',
      },
      title: 'AI-avustaja',
    },
    getStart: 'Aloita',
    getStartedForFree: 'Aloita ilmaiseksi',
    howItWork: {
      desc: 'Noam integroi tekoälymallien avulla käyttäjille älykkääseen kokemukseen monikielisen verkkosivun kääntämiseksi ja yhteenvetämiseksi, PDF:n ja kuvan kääntämiseksi sekä videon kääntämiseksi ja yhteenvetämiseksi',
      title: 'Kuinka se toimii',
    },
    lastBlock: { desc: 'Parhaampi AI-käännös sulavamman lukukokemuksen takaamiseksi' },
    top: {
      desc: 'Noam on ilmainen AI-selainlaajennos, joka auttaa sinua kääntämään ja yhteenvetämään verkkosivuja, videoita ja PDF- sisällön.\n      Liity Noamiin ja kokeile taikaa!',
      title1: 'Yksi Taika',
      title2: 'Yksi klikkaus',
    },
    userReviews: {
      desc: 'Viisipäiväiset arvostelut Chrome Web Storesta',
      title: 'Käyttäjäarvostelut',
    },
  },
  installTips: {
    btn: 'Yritä nyt',
    text: 'Asenna "Noam Browser Plugin" saadaksesi lisää ominaisuuksia! Verkkoyhteenvetäminen,\n    verkkovideoiden yhteenveto ja paljon muuta!',
  },
  locale: {
    af: 'afrikaans',
    am: 'amhari',
    ar: 'arabia',
    as: 'assamea',
    auto: 'Automaattinen tunnistus',
    az: 'azerbaidžani',
    ba: 'baškiri',
    bg: 'bulgarialainen',
    bn: 'bengali',
    bo: 'tiibetin kieli',
    bs: 'bosnialaista',
    ca: 'katalaani',
    cs: 'tšekki',
    cy: 'walesilainen',
    da: 'tanska',
    de: 'saksa',
    dsb: 'alasen sorbi',
    dv: 'divehi',
    el: 'kreikka',
    en: 'englanti',
    es: 'espanja',
    et: 'viro',
    eu: ' baski',
    fa: 'persialainen',
    fi: 'suomi',
    fil: 'filippiini',
    fj: 'fijiläinen',
    fr: 'ranskan',
    frCA: 'ranska (Kanada)',
    ga: 'irlantilainen',
    gl: 'galicialainen',
    gom: 'konkani',
    gu: 'gujarati',
    ha: 'Hausa',
    he: 'heprea',
    hi: 'hindi',
    hr: 'kroaatti',
    hsb: 'ylin sorbi',
    ht: 'haitin kreoli',
    hu: 'unkari',
    hy: 'armenialainen',
    id: 'indonesian',
    ig: 'igbo',
    ikt: 'Inuinnaqtun',
    is: 'islanti',
    it: 'italialainen',
    iu: 'inuktitutti',
    iuLatn: 'inuktitutti (latinaa)',
    ja: 'japani',
    ka: 'georgialainen',
    kk: 'kazakki',
    km: 'khmeri',
    kmr: 'kurdi (pohjoinen)',
    kn: 'kannada',
    ko: 'korealainen',
    ku: 'Kurdin kieli (keskikuurdin)',
    ky: 'kyrgyz',
    ln: 'lingala',
    lo: 'Lao',
    lt: 'lietuainen',
    lug: 'Ganda',
    lv: 'latvialainen',
    lzh: 'Kiina (kirjallinen)',
    mai: 'Maithili',
    mg: 'malagasi',
    mi: 'maori',
    mk: 'makedonialainen',
    ml: 'malayalam',
    mnCyrl: 'mongoli (kyrillinen)',
    mnMong: 'mongoli (perinteinen)',
    mr: 'marathi',
    ms: 'malaiji',
    mt: 'malta',
    mww: 'Hmong Daw',
    my: 'Myanmar (burmese)',
    nb: 'norjalainen',
    ne: 'nepali',
    nl: 'hollanti',
    noSearchLang: 'Kieltä ei tueta',
    nso: 'Pohjoisesotho',
    nya: 'nyanja',
    or: 'odia',
    otq: 'Querétaro-otomi',
    pa: 'punjabia',
    pl: 'puola',
    placeholder: 'Haku',
    prs: 'Dari',
    ps: 'pashto',
    pt: 'portugali (Brasilia)',
    ptPT: 'portugali (Portugali)',
    ro: 'romani',
    ru: 'venäläinen',
    run: 'Rundi',
    rw: 'kinyarwanda',
    sd: 'sindhi',
    si: 'singalalainen',
    sk: 'slovakki',
    sl: 'sloveni',
    sm: 'samoa',
    sn: 'shona',
    so: 'somali',
    sq: 'albanialainen',
    srCyrl: 'serbian (kyrillinen)',
    srLatn: 'serbia (latinalainen)',
    st: 'sesotho',
    sv: 'ruotsi',
    sw: 'swahili',
    ta: 'tamil',
    te: 'telugu',
    th: 'thai',
    ti: 'tigrinja',
    tk: 'turkmeni',
    tlhLatn: 'Klingoni',
    tlhPiqd: 'klingoni (pIqaD)',
    tn: 'setswana',
    to: 'tonganilainen',
    tr: 'turkkilainen',
    tt: 'tatari',
    ty: 'tahiti',
    ug: 'uiguuri',
    uk: 'ukrainalainen',
    ur: 'urdu',
    uz: 'Uzbekki (latinaa)',
    vi: 'vietnamilainen',
    xh: 'xhosa',
    yo: 'joruba',
    yua: 'yukatekki-maya',
    yue: 'Kantoni (perinteinen)',
    zh: 'kiinalainen',
    zhHans: 'Kiina (yksinkertainen kirjasointi)',
    zhHant: 'Perinteinen kiina',
    zu: 'zulu',
  },
  login: {
    and: 'ja',
    btn: 'Kirjaudu sisään Google -tilillä',
    btn1: 'Kirjaudu sisään nyt',
    desc: 'Kirjaudu sisään saadaksesi lisää kokemuksia',
    policy: 'Tietosuojakäytäntö',
    terms: 'Käyttöehdot',
    tips: 'Rekisteröitymällä hyväksyn',
    title: 'Tervetuloa Noamiin',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Seuraa', twitter: 'Twitter' },
    legal: { policy: 'Tietosuojakäytäntö', terms: 'Käyttöehdot', title: 'Legaali' },
    product: {
      image: 'Kuvan kääntäminen',
      pdf: 'PDF-käännös',
      title: 'Tuotteet',
      video: 'Videon kääntäminen ja yhteenveto',
      web: 'Verkkösuoritus & Yhteenveto',
    },
    resources: { title: 'Resurssit' },
    tools: { title: 'Työkalut', pdf: 'PDF-käännös' },
  },
  pageHeader: {
    contact: 'Yhteystiedot',
    help: 'Apua',
    logout: 'Kirjaudu ulos',
    logoutSucc: 'Kirjautunut ulos.',
    pricing: 'Hinnoittelu',
    settings: 'Asetukset',
    signUp: 'Kirjaudu sisään',
  },
  pdf: {
    autoDetect: 'Automaattinen tunnistus',
    cancelBtn: 'Peruuta',
    cancelUpload: 'Peruuta',
    chatPdf: {
      summaryError: 'Yhteenveto epäonnistui, yritä myöhemmin uudelleen',
      chatError: 'Chatti epäonnistui, yritä myöhemmin uudelleen',
      Search: 'Haku',
      cancel: 'Peruuta',
      chatTitle: 'Tervetuloa Noamiin! Tässä yhteenveto PDF-tiedostostasi:',
      clear: 'Selkeä',
      clearContent:
        'Tämä aloittaa uuden keskustelun. Nykyistä keskustelua ei tallenneta. Oletko varma?',
      clearDialogTitle: 'Vahvistathan',
      clearSucc: 'Hyväksytty',
      copy: 'Kopioi',
      copySucc: 'Kopioitu',
      delete: 'Poista',
      deleteCancel: 'Peruuta',
      deleteContent: 'Tätä PDF-tiedostoa ei voida palauttaa poistamisen jälkeen. Oletko varma?',
      deleteOk: 'Poista',
      deleteSuccess: 'Poistettu',
      deleteTitle: 'Vahvista poisto',
      expand: 'Kollapsi',
      historyTitle: 'Historia',
      listError:
        'Lukulistan lataaminen epäonnistui. Yritä myöhemmin uudelleen tai ota yhteyttä tukeen.',
      loading: 'Ladataan...',
      noDataDesc: 'Historiaa ei ole vielä.',
      noMore: 'Ei lisää sisältöä.',
      placeholder: 'Kysy mitä tahansa tästä PDF:stä',
      summaryTitle: 'Sinulle saattaa olla mielenkiintoa nämä kysymykset:',
    },
    collectionEmpty: 'Kokoelmasi on tyhjä.',
    collectionTab: 'Muistiinpanot',
    dataLoading: 'Ladataan...',
    dialogContent: 'Oletko varma, että haluat poistaa tämän?',
    dialogTitle: 'Vahvistathan',
    download: {
      both: 'kaksikielinen',
      btn: 'Tallenna',
      cancel: 'Tämän ikkunan sulkeminen peruuttaa PDF:n latauksen. Haluatko varmasti perua?',
      desc: 'Tallenna laitteeseen: Lataa käännökset kuvina; Tallenna ja tulosta: Lataa käännökset alkuperäisessä muodossa kopiointituenneytyksen kanssa.',
      download: 'Lataa',
      downloadMsg1: 'PDF:n kääntymisen eteneminen:',
      downloadMsg2: 'Arvioitu jäljellä oleva aika:',
      downloadSucc: 'PDF on valmis! Klikkaa tallentaaksesi.',
      downloadTip: 'PDF:n lataaminen. Älä sulje tätä ikkunaa välttääksesi latausvirheitä.',
      error: 'Tallennus epäonnistui. Kokeile tulostamista sen sijaan.',
      fileName: 'Tiedostonimi:',
      fileType: 'Tiedostotyyppi:',
      loading: 'Tallennetaan...',
      loading2: 'Ladataan...',
      minute: 'Minuutteja...',
      msg1: 'Jotkut tässä asiakirjassa olevista käännöksistä ovat alkuperäisen tekstin pitempiä ja voivat päällekkäistyä ladatussa tiedostossa. Suosittelemme lukemista verkkosivulla.',
      msg2: 'Käännös ei ole vielä valmis. Lataa, kun käännös on valmis.',
      msg3: '2. Jotkut käännökset ovat liian pitkiä. Lue verkkosivua, jotta voit välttää tekstin päällekkäisyyttä.',
      msg4: 'Käännöstöitä on käynnissä. Yritä uudelleen, kun ne on valmiita.',
      progress:
        'PDF:n kääntäminen. Edistyminen: {{progress}}, Arvioitu jäljellä oleva aika: {{minutes}} minuuttia...',
      save: 'Tallenna laitteeseen',
      savePrint: 'Tallenna ja tulosta',
      success: 'Ladattu',
      trans: 'Vain käännös',
      transContinue: 'Jatka kääntämistä',
    },
    downloadBtn: 'Lataa',
    dragTipModal: {
      black: 'avaruus',
      leftKey: 'vasen nappi',
      ok: 'Ymmärretty',
      press: 'Painike',
      tips: 'vetää ja tarkastella',
    },
    entry: 'PDF-tiedostot',
    fileErrMsg:
      'Tiedoston lukeminen epäonnistui. Yritä myöhemmin uudelleen tai ota yhteyttä tukeen.',
    fileMsg: 'Nykyinen tiedostokoko:',
    fileMsg2: 'Lataa tiedosto, jonka koko on alle 300 MB.',
    freeBannerBtn: 'Päivitys',
    freeBannerTips: 'Ilmaisten PDF-käännösten raja saavutettu',
    guide: {
      placeholder: 'Liitä PDF-osoite tähän',
      start: 'Aloita kääntäminen',
      text1: 'Kaksikielinen lukeminen',
      text2:
        'Lue kaksikielisesti vertaillaksesi alkuperäistekstiä ja käännöstä vierekkäin, mikä parantaa tehokkuuttasi.',
      text3: 'Chattaa PDF-tiedostostasi',
      text4:
        'AI:n avulla toteutettu analyysi ja yhteenveto. Kysy kysymyksiä PDF-tiedostostasi ja saad kysymyksiin välittömiä vastauksia.',
      text5: 'Tarkka & tehokas',
      text6:
        'AI:n avulla toimiva PDF-kääntäminen suuremman tarkkuuden ja tehokkuuden saavuttamiseksi.',
      title1: 'Kaksikielinen kääntäminen',
      title2: 'Chattaa PDF-tiedostosi kanssa',
      toast: 'Syötä kelvollinen verkkoon sijaitseva PDF-linkki, joka päättyy .pdf',
    },
    hasTransTask: 'Käännöstyö on käynnissä. Odota hetki.',
    hoverTrans: 'Hiirellä käännettävät kappaleet',
    initial: 'Käännä PDF',
    installText: 'Yksi ja ainoa ratkaisusi päivittäisiin käännöksiin.',
    installText2: 'Asenna ensin laajennus',
    installTips:
      'Asenna laajennus saadaksesi lisää PDF-käännöksiä ja sujuvempia verkkosivukäännöksiä:',
    kw: 'vakio',
    link: 'linkki',
    listError:
      'PDF-tiedostojen lataaminen epäonnistui. Yritä myöhemmin uudelleen tai ota yhteyttä tukeen.',
    memoTotalCount: 'yhteensä 1 kappale',
    new: 'uusi tiedosto',
    noId: 'Tiedoston tunnistetta ei löytynyt.',
    notPdf: 'Vain PDF-tiedostot.',
    okBtn: 'Poista',
    okBtn2: 'Ymmärretty',
    original: 'Alkuperäinen',
    parallel: 'rinnakkainen',
    parseErrDialogContent:
      'Tätä PDF-linkkiä ei voida kääntää suoraan. Lataa PDF tiedosto ja lataa se ylös kääntämistä varten.',
    parseErrTips: 'Tiedoston jäsentäminen epäonnistui',
    parseFileToast:
      'Tiedoston jäsentäminen epäonnistui. Yritä myöhemmin uudelleen tai ota yhteyttä tukeen.',
    pdfLoading: 'Analysoidaan...',
    searchPlaceholder: 'Haku',
    selectTrans: 'Valitse teksti käännettäväksi',
    shareBtn: 'Jaa',
    shareBtnText1: 'Luo jakolinkki',
    shareBtnText2: 'Päivitä jaettu sisältö',
    shareModal: {
      cancel: 'Peruuta',
      copy: 'Kopioi',
      copySucc: 'Linkki kopioitu',
      custom: 'Mukauta:',
      errMsg: 'Valittua sisältöä ei ole vielä täysin käännetty. Käännä se ennen jakamista.',
      gen: 'Jaa',
      modify: 'Muokkaa',
      notSupport: 'Tätä kieltä ei tällä hetkellä tueta.',
      page: 'Sivut',
      pageNuErr: 'Syötä kelvollinen sivunumero.',
      range: 'Alue:',
      remain: 'jäljellä oleva',
      remain1: 'Arvioitu kokonaisaika:',
      search: 'Haku',
      settings: 'Jaa asetukset:',
      shareSetting: 'Jakaminen asetukset',
      shareText: 'Jaa',
      shareTips: 'Jaa käännetty PDF-linkki ystäviesi kanssa:',
      sourceLang: 'Lähettäjä:',
      target: 'Vastaanottaja:',
      text1: 'Jakamisasetukset',
      text2: 'Luo jakolinkki',
      totalPage: 'Yhteensä 1 sivu',
      trans: 'Käännä',
      translateTips: 'Vinkki: Jos käännös vie aikaa, voit sulkea tämän ikkunan ja jakaa myöhemmin.',
      translating: 'Käännetään PDF:ää...',
      update: 'Päivitä jakamislinkki',
    },
    shareMsg1: 'Jaa linkki luotu.',
    shareMsg2: 'Jaettu sisältö päivitetty.',
    shareMsg3: 'Jaa-linkin luonti epäonnistui. Yritä myöhemmin uudelleen tai ota yhteyttä tukeen.',
    shareMsg4:
      'Jaetun sisällön päivitys epäonnistui. Yritä myöhemmin uudelleen tai ota yhteyttä tukeen.',
    shareTips: 'PDF-käännöstäsi on valmis! Jaa se ystävillesi.',
    start: 'Aloita ilmainen kokeilu',
    thumbnail: 'Sisällysluettelo',
    toast1: 'PDF:n lataaminen. Yritä myöhemmin uudelleen.',
    toast2: 'PDF-sisältöä käsitellään. Dialogia ei tällä hetkellä tueta.',
    toast3: 'Lataus on meneillään. Yritä uudelleen, kun lataus on valmis.',
    toolbar: { Adjust: 'Säädä', autoFit: 'Automaattinen sovitus' },
    trans: 'Käännös',
    transSucc: 'Käännös onnistui!',
    unLoginToast: 'Kirjaudu sisään käyttääksesi tätä ominaisuutta.',
    uploadBtn: 'Lataa',
    uploadErr: 'Tiedoston lataus epäonnistui. Yritä myöhemmin uudelleen tai ota yhteyttä tukeen.',
    uploadErrSignUrl:
      'Lataus-URL:n hakeminen epäonnistui. Yritä myöhemmin uudelleen tai ota yhteyttä tukeen.',
    uploadMsg1: 'Vedä ja pudota tiedosto tähän.',
    uploadMsg2: 'Tuetut tiedostotyypit: PDF  |  Maksimi tiedostokoko: 300MB',
    uploadMsg3: 'Napsauta valitaksesi tai raahaa tiedostoja tänne.',
    uploading: 'Ladataan',
    uploadingMsg: 'Ladataan. Odota hetki.',
    uploadingMsg1: 'Tiedosto ladataan. Yritä myöhemmin uudelleen.',
    uploadingMsg2: 'Tiedostoa muunnetaan tällä hetkellä. Yritä myöhemmin uudelleen.',
    uploadingMsg3:
      'Muunnoksen edistymisen pyytäminen epäonnistui. Yritä myöhemmin uudelleen tai ota yhteyttä tukeen.',
    uploadingMsg4:
      'Noam ei voi päästä käsiksi paikallisiin tiedostoihin. Lataa manuaalisesti PDF-tiedosto käännettäväksi.',
    uploadingMsg5:
      'Tiedoston URL-osoitetta ei voitu noutaa. Yritä myöhemmin uudelleen tai ota yhteyttä tukeen.',
    video: 'video',
    vipBannerBtn: 'Päivitys',
    vipBannerTips: 'Olet saavuttanut kuukauden PDF-käännösrajallesi.',
    webTrans: 'Täydellinen ristireferenssi',
  },
  pricing: {
    FAQ: 'UKK',
    FQAObj: {
      a1: 'Kyllä, Noam tarjoaa ilmaisen suunnitelman, jota voit käyttää heti.',
      a2: 'Tarjoamme kolme jäsenyyden suunnitelmaa: Pro, Pro+ ja Enterprise. Voit valita maksamisen kuukausittain tai vuosittain. Vuosittainen laskutustapa tarjoaa merkittäviä säästöjä.',
      a3: 'Kaikki ominaisuudet ovat saatavilla molemmilla suunnitelmilla. Pääero on hinta: vuotuiset tilaukset ovat kokonaisuudessaan halvempia. Kuukausittaiset tilaukset laskutetaan joka kuukausi, kun taas vuotuiset suunnitelmat laskutetaan kerran vuodessa.',
      a4: 'Voit peruuttaa tilauksesi milloin tahansa Tiliasetuksista.',
      q1: 'Onko ilmainen suunnitelma saatavilla?',
      q2: 'Mitkä hinnoittelusuunnitelmat ja maksuvaihtoehdot ovat saatavilla?',
      q3: 'Mitä eroa on kuukausittaisen ja vuosittaisen tilauksen välillä?',
      q4: 'Miten peruutan tilaukseni?',
    },
    around: 'Ympäri',
    billedMonthly: 'Laskutetaan kuukausittain',
    billedYearly: 'Laskutetaan vuosittain',
    day: 'päivä',
    desc: 'Vertaa suunnitelmia ja valitse paras',
    detailedCompare: 'Vertaa suunnitelmia',
    discount: '20 % alennus',
    enterprise: {
      benefit1: 'Priorisoitu asiakastuki',
      benefit2: 'Monet käyttäjät',
      benefit3: 'Mukautetut Ratkaisut',
      benefit5: 'Erityinen asiakkuusvastaava',
      btn: 'Ota yhteyttä',
      recommendText: 'Mukautetut suunnitelmat (≥3 henkilöä)',
      talkToUs: 'Ota yhteyttä',
    },
    free: {
      benefit1: 'Välitön kääntäminen 100 kertaa päivässä',
      benefit2: 'Verkkosivun kääntäminen ja yhteenveto',
      benefit3: '30 kuvankäännöstä',
      benefit4: 'Videon kääntäminen ja yhteenveto',
      benefit5: '10 PDF-käännöstä',
      benefit6: '5 000 tokenia',
      btn: 'Provoita ilmaiseksi',
      recommendText: 'Ilmainen kokeilu',
    },
    imageTranslation: 'Kuvavertaus',
    month: 'kuukausi',
    monthly: 'Kuukausittain',
    pageTitle: 'Hinnasto',
    pdf: {
      chat: 'PDF-kiertymiselle liittyvät kysymykset',
      maxPage: 'Maksimi sivuja per PDF',
      translation: 'PDF-käännös',
    },
    preMonth: 'Kuukaudessa',
    pro: {
      benefit1: 'Priorisoitu asiakastuki',
      benefit2: '1 000 000 tokenia kuukaudessa',
      benefit3: 'Verkkosivun kääntäminen ja yhteenveto',
      benefit4: '200 kuvan käännöstä',
      benefit5: 'Videon kääntäminen ja yhteenveto',
      benefit6: '200 PDF-käännöstä',
      btn: 'Aloita',
      recommendText: 'Suosituimmat',
    },
    proPlus: {
      benefit1: 'Priorisoitu asiakastuki',
      benefit2: '3 000 000 tokenia kuukaudessa',
      benefit3: 'Verkkosivun kääntäminen ja yhteenveto',
      benefit4: '500 kuvankäännöstä',
      benefit5: 'Videon kääntäminen ja yhteenveto',
      benefit6: '500 PDF-käännöstä',
      recommendText: 'Paras arvo',
    },
    video: { summary: 'Videon yhteenveto', translation: 'Videon kääntäminen' },
    web: {
      contrastiveTranslation: 'Kaksikielinen käännös',
      dictionaryTranslation: 'Valintojen kääntäminen',
      hoverTranslation: 'Hover-käännös',
      instantTranslation: 'Välitön käännös',
      summary: 'Verkkosivun yhteenveto',
    },
    yearly: 'Vuosittain',
  },
  privacy: {
    block1:
      'Noam ("Noam", "me", "meidän" tai "emme") kunnioittaa yksityisyyttäsi ja sitoutuu suojelemaan kaiken tietoa, jonka saamme sinusta tai sinusta. Tämä tietosuojakäytäntö kuvaa käytäntöjämme henkilökohtaisen tietojen keräämisestä tai käytöstä verkkosivustomme, sovellusten ja palvelujen (yhdessä "Palvelut") käytöstä. Tämä tietosuojakäytäntö ei koske sisältöä, jota käsittelemme liiketoimintatuotteidemme asiakkaiden puolesta, kuten API:tamme. Tämän tiedon käyttöön sovelletaan asiakas sopimusta, joka kattaa näiden tuotteiden käyttöön ja käyttöön.',
    block10:
      'Suoritamme kaupallisesti järkeviä teknisiä, hallinnollisia ja organisaatiollisia toimenpiteitä suojellaksemme verkossa ja offline-tilassa olevaa henkilökohtaista tietoa hävitykseltä, väärinkäytöltä sekä oikeuttomalta pääsyltä, paljastumiselta, muuttamiselta tai vihamielisiltä toiminnoilta. Kuitenkaan internetin tai sähköpostin välitys ei voi taata täydellistä turvallisuutta tai tarkkuutta. Erityisesti meille tai meiltä lähetetyt sähköpostit eivät välttämättä ole turvallisia. Siksi sinun tulee olla erityisen varovainen päätettäessä, mitä tietoa lähetät meille palvelun tai sähköpostin kautta. Lisäksi emme ole vastuussa palvelun tai kolmansien osapuolten verkkosivustojen yksityisyyden asetusten tai turvatarkastusten estämisestä. Säilytämme henkilökohtaista tietojasi niin kauan kuin se on tarpeen palveluiden tarjoamiseksi tai muista laillisista liiketoimintatarkoituksista, kuten kiistojen ratkaisemiseksi, turvallisuus- ja suojelusyistä tai lakiasihteellisten velvoitteidemme noudattamiseksi. Aika, jonka ajan säilytämme henkilökohtaista tietoa, riippuu monista tekijöistä, kuten tietojen määrästä, luonteesta, arkaluontoisuudesta, oikeuttoman käytön tai paljastamisen mahdollisista riskeistä, tietojen käsittelyn tarkoituksista sekä muista oikeudellisesti sitovista huomioonottoista.',
    block11:
      'Tätä tietosuojakäytäntöä voi päivittää ajallaan. Kun teemme niin, julkaisemme päivitetyn version tässä sivussa, ellei sovellettava laki vaadi muuta.',
    block12:
      'Jos sinulla on kysymyksiä tai huolenaiheita tästä tietosuojakäytännöstä, ota yhteyttä asiakaspalveluumme. Sähköposti:',
    block2:
      'Keräämme seuraavaa henkilökohtaista tietoa ("henkilökohtaista tietoa") sinusta liittyen:',
    block3:
      'Sinun antamasi tietoja: Kun luot tilin käyttääksesi palveluitamme tai kommunikoidaksesi kanssamme, keräämme henkilökohtaisia tietoja seuraavasti:',
    block4:
      'Palvelujen käytöstä automaattisesti saatu henkilökohtainen tieto: Kun käytät, käyttäydyt tai vuorovaikutat palvelujen kanssa, saamme seuraavaa tietoa käytöstäsi, käyttäytymisestäsi tai vuorovaikutuksestasi (”tekniikkaa koskevia tietoja”):',
    block5: 'Voimme käyttää henkilökohtaista tietoa seuraaviin tarkoituksiin:',
    block6:
      'Yhteenveto tai tunnistamattomaksi muokattu tieto: Voimme yhteenvetää tai muuttaa henkilökohtaisia tietoja tunnistamattomiksi estääksemme niiden uudelleenkäytön tunnistamisen tarkoituksessa, ja käyttää tällaista tietoa palvelujemme tehokkuuden analysoimiseen, palvelujemme parantamiseen ja ominaisuuksien lisäämiseen, tutkimuksen tekemiseen sekä vastaaviin tarkoituksiin. Lisäksi voimme analysoida palvelujemme käyttäjien yleistä käyttäytymistä ja ominaisuuksia sekä jakaa yhteenvetetyt tiedot kolmansille osapuolille, julkaista tällaisia yhteenvetettyjä tietoja tai tehdä ne yleisesti saataville. Yhteenvetetyt tiedot voivat kerätä palvelujen kautta, evästeiden avulla sekä muilla tässä tietosuojakäytännössä kuvatuilla tavoilla. Tunnistamattomaksi muokatut tiedot pidetään ja käytetään anonymisessa tai tunnistamattomassa muodossa, eikä yritetä palauttaa niiden tunnistettavuutta ellei laki vaadi sitä.',
    block7:
      'Tietyissä tapauksissa voimme välittää henkilökohtaista tietojasi kolmansille osapuolille ilman, ellei laki vaadi, erillistä ilmoitusta sinulle:',
    block8:
      'Sijaintistasi riippuen Euroopan talousalueella, Yhdistyneessä kuningaskunnassa ja maailmanlaajuisesti sijaitseville henkilöille voi olla tiettyjä lainmukaisia oikeuksia henkilökohtaiseen tietoonsa liittyen. Esimerkiksi sinulla voi olla oikeus:',
    block9:
      'Palvelussa voi olla linkkejä muihin verkkosivustoihin, jotka eivät ole Noamin hallinnoimia tai hallittuja, mukaan lukien sosiaalisen median palvelut ("kolmannen osapuolen verkkosivustot"). Kolmannen osapuolen verkkosivustoille jakamasi tietojen hallintaa säätelevät kolmannen osapuolen verkkosivustojen erityiset tietosuojakäytännöt ja palveluehdot, eivätkä tätä tietosuojakäytäntöä. Tarjoamme nämä linkit convenience -syistä, eikä tämä tarkoita hyväksyntäämme tai tarkasteluaamme näitä verkkosivustoja. Ota suoraan yhteyttä kolmannen osapuolen verkkosivustoihin saadaksesi tietoa heidän tietosuojakäytännöistään ja ehdotuksistaan.',
    subBlock1:
      'Tilin tiedot: Kun luot tiliä alustallamme, keräämme tietoja tilistäsi, kuten nimesi, yhteystiedot, tilin kirjautumistiedot, maksukorttitiedot ja tapahtumahistoria ("Tilin tiedot").',
    subBlock10: 'Palvelujen tarjoaminen, hallinta, ylläpito ja/tai analysointi;',
    subBlock11: 'Yhteydenpito sinun kanssasi',
    subBlock12: 'Uusien tuotteiden ja palvelujen kehittäminen;',
    subBlock13:
      'Väärennösten, rikollisen toiminnan tai palvelujemme väärinkäytön estäminen sekä tietotekniikkajärjestelmien, arkkitehtuurin ja verkkojen turvallisuuden suojeleminen;',
    subBlock14: 'Yrityssiirtojen suorittaminen;',
    subBlock15:
      'Lakitehtävien ja oikeudenkäyntien noudattaminen, oikeuksiemme, yksityisyyden, turvallisuuden tai omaisuuden suojeleminen sekä meidän yhteenliittyneiden, sinun tai muiden kolmansien osapuolten niiden suojeleminen.',
    subBlock16:
      'Toimittajat ja palveluntarjoajat: Yrityksen toiminnallisten tarpeiden täyttämiseksi ja tiettyjen palvelujen ja toimintojen suorittamiseksi voimme jakaa henkilökohtaista tietoa toimittajille ja palveluntarjoajille, kuten isännöinti- ja pilvipalveluntarjoajille, muille tietotekniikan palveluntarjoajille, sähköpostiviestintäohjelmistolle sekä verkkonalytiikkaa tarjoaville palveluntarjoajille jne. Nämä kumppanit voivat käyttää, käsitellä tai tallentaa henkilökohtaista tietoa vain ohjeistuksemme mukaan suorittaessaan meidän puolestamme tehtäviä velvollisuuksiaan.',
    subBlock17:
      'Liiketoiminnan siirrot: Jos osallistumme strategisiin transaktioihin, uudelleenjärjestelyihin, konkurssiin, konkurssinübernameihin tai siirrämme palveluja toiselle palveluntarjoajalle (yhdistelmä nimitetään "Transaktioiksi"), henkilökohtainen tietosi ja muu tieto voivat jaottaa transaktion vastapuolten ja muiden Transaktioita avustavien osapuolten kanssa due diligence -prosessin aikana sekä siirtää Transaktioiden osana muiden varojen kanssa seuraajayhtiöön tai tytäryhtiöön.',
    subBlock18:
      'Lakimääräykset: Voimme jakaa henkilökohtaista tietojasi hallintoviranomaisille, alan同行eille tai muille kolmansille osapuolille, mukaan lukien vuorovaikutustietosi palvelujemme kanssa, (1) jos laki sitä vaatii tai jos uskomme tällaista toimenpidettä olevan tarpeen lakisääteisten velvoitteiden noudattamiseksi; (2) oikeuksiemme tai omaisuuttamme suojelemiseksi ja puolustamiseksi; (3) jos yksipuolisesti päätämme, että käyttöehdoistamme, politiikoistamme tai laeista on rikkomus; (4) petosten tai muiden laittomien toimien havaitsemiseen tai estämiseen; (5) tuotteidemme, työntekijöidemme tai käyttäjien tai julkisen turvallisuuden, vakauden, eheyden suojelemiseksi; tai (vi) oikeudellisen vastuun puolustamiseksi.',
    subBlock19: 'Käytä pääsyä henkilökohtaiseen tietoon ja tietoon siitä, miten sitä käsitellään.',
    subBlock2:
      'Kun käytät palveluitamme, keräämme henkilökohtaisia tietoja syötteistäsi, tiedostolatauksista tai meille antamastasi palautteesta (”sisältö”).',
    subBlock20: 'Pyydä henkilötietojesi poistamista rekistereistämme.',
    subBlock21: 'Tarkista tai päivitä henkilökohtaiset tietosi.',
    subBlock22: 'Lähetä henkilökohtainen tietosi kolmannelle osapuolelle (tietojen siirrettävyys).',
    subBlock23: 'Rajaa, miten käsittelemme henkilökohtaista tietojasi.',
    subBlock24:
      'Peruuta suostumuksesi – jos käsittelyssä perustumme suostumukseen oikeudellisena perusteena, voit peruuttaa suostumuksesi milloin tahansa.',
    subBlock25: 'Etkää hyväksykö henkilökohtaisen tietosi käsittelytapoja?',
    subBlock26: 'Palvelujemme parantaminen ja tutkimuksen suorittaminen;',
    subBlock3:
      'Viestintätiedot: Jos lähetät meille viestejä, keräämme nimesi, yhteystietosi ja viestien sisällön ("viestintätiedot").',
    subBlock4:
      'Sosiaalisen median tietoja: Meillä on sivuja sosiaalisen median verkkosivustoilla kuten Instagram, Facebook, Medium, Twitter, YouTube ja LinkedIn. Kun vuorovaikutat sosiaalisen median sivuillamme, keräämme henkilökohtaisia tietoja, jotka valitset jakaa meidän kanssamme, kuten yhteystietojasi ("sosiaaliset tiedot"). Lisäksi sosiaalisen median sivuillemme isännöivät yritykset voivat toimittaa meille yhteenvetetyt tietoja ja analyysiä sosiaalisen median toiminnastamme.',
    subBlock5:
      'Lokitiedot: Tietoja, jotka selain lähettää automaattisesti palvelujemme käytön aikana. Lokitietoihin kuuluvat Internet Protocol (IP)-osoitteesi, selaimen tyyppi ja asetukset, pyyntöjen päivämäärä ja aika sekä tapa, jolla vuorovaikutat verkkosivustomme kanssa.',
    subBlock6:
      'Käyttötiedot: Voimme automaattisesti kerätä tietoa palvelun käytöstäsi, kuten siitä, millaisia sisältöjä tarkastelet tai johon vuorovaikutat, mitkä ominaisuuksia käytät, mitä toimenpiteitä teet, sekä aikavyöhykkeestäsi, maasta, pääsyn päivämäärästä ja ajasta, käyttäjäagentista ja versiosta, tietokoneen tai mobiililaitteen tyypistä sekä tietokoneyhteydestäsi.',
    subBlock7:
      'Laitetiedot: Tätä sisältävät laitteen nimi, käyttöjärjestelmä, laitteen tunniste ja käytössä oleva selain. Kerätty tieto voi riippua käytetystä laitetyypistä ja sen asetuksista.',
    subBlock8:
      'Evästeet: Käytämme evästeitä palvelujemme toimintaan, hallintaan sekä käyttökokemuksen parantamiseen. "Eväste" on tietoa, jota vierailemasi verkkosivusto lähettää selaimellesi. Voit asettaa selaimen hyväksymään kaikki evästeet, hylkäämään kaikki evästeet tai ilmoittamaan, kun evästeitä annetaan, jotta voit päätellä jokaisella kerralla, hyväksytkö ne. Evästeiden hylkääminen voi kuitenkin estää sinua käyttämästä tiettyjä verkkosivuston alueita tai ominaisuuksia tai vaikuttaa niiden näyttöön tai toimintaan negatiivisesti. Lisätietoja evästeistä saat osoitteesta All About Cookies (Kaikki evästeistä).',
    subBlock9:
      'Analytiikka: Voimme käyttää variousia verkkoanalytiikka tuotteita, jotka käyttävät evästeitä auttamaan meitä analysoimaan, miten käyttäjät käyttävät palveluitamme, ja parantamaan käyttökokemustasi palveluita käytettäessä.',
    subTitle1: 'Keräämme henkilökohtaisia tietoja',
    subTitle2: 'Miten käytämme henkilökohtaista tietoa',
    subTitle3: 'Henkilötietojen paljastaminen',
    subTitle4: 'Omat oikeutesi',
    subTitle5: 'Linkit muihin verkkosivustoihin',
    subTitle6: 'Tietojen turvallisuus ja säilyttäminen',
    subTitle7: 'Yksityisyyspolitiikan muutos',
    subTitle8: 'Miten ottaa meihin yhteyttä',
    title: 'Tietosuojakäytäntö',
    updateTime: 'Päivitetty: 15. maaliskuuta 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Hyväksy kaikki',
    text: 'Jotta voimme parantaa käyttökokemustasi, käytämme evästeitä sisällön ja palveluiden räätälöimiseen.',
    title: 'Tämä verkkosivu käyttää evästeitä',
  },
  slogen: 'Helpoin tekoälyavustaja',
  stripe: {
    contact: 'Ota meihin yhteyttä osoitteeseen contact@noam.tools mikäli sinulla on kysyttävää!',
    fail: {
      btn: 'Yritä uudelleen',
      text1: 'Maksua ei voitu käsitellä.',
      text2: 'Tarkista yhteys ja yritä uudelleen.',
      title: 'Maksu epäonnistui',
    },
    succ: {
      btn: 'Mennään',
      text1: 'Tervetuloa Noamiin',
      text2: 'Aloitetaanpa!',
      title: 'Onnittelut',
    },
  },
  terms: {
    block1: 'Kiitos Noam:n käytöstä!',
    block10:
      'Maksut ja laskutukset. Sinun tulee maksaa kaikki maksut ("Maksut") sovellettavan hintasivun hintojen ja ehtojen mukaisesti tai meidän välillä kirjallisesti sovitulla tavalla. pidätämme oikeuden korjata hinnasto-ongelmia tai virheitä vaikka olisimme lähettäneet laskuja tai vastaanottaneet maksun. Sinun tulee toimittaa täydellinen ja tarkka laskutustiedot, mukaan lukien voimassa oleva ja hyväksytty maksutapa. Laskutamme maksutapaa periodisesti sovitulla tavalla, mutta voimme muuttaa laskutuspäivää kohtuullisesti. Antaudet Noamille, sen liittymille ja kolmansien osapuolten maksunvälittäjille oikeuden periä maksuasi maksutavasta. Jos maksusi epäonnistuu, annamme sinulle kirjallisen ilmoituksen ja voimme keskeyttää pääsyn palveluun kunnes maksu on vastaanotettu. Tämän sopimuksen muissa tapauksissa erikseen määrättyjä tapauksia lukuun ottamatta maksut eivät ole palautettavia.',
    block11:
      '(b) Verot. Muuten mainittua lukuun ottamatta maksuissa ei sisälly mitään liittovaltion, osavaltion, paikallisen tai ulkomaalaisen hallinnon veroja, tulleja tai vastaavia arvioita ("Verot"). Olet vastuussa kaikista ostoksiisi liittyvistä veroista, lukuun ottamatta veroja, jotka perustuvat nettovoittoomme, joista laskutamme sinua. Suostut maksamaan nämä verot nopeasti, antamaan meille laillisesti päteviä tietosuojaselosteita sekä hankkimaan tarvittavat suostumukset tällaisen datan käsittelyä varten, ja takaat meille, että käsittelet tätä dataa sovellettavan lain mukaisesti.',
    block12:
      '(c) Hintamuutokset. Voimme muuttaa hintojamme ilmoittamalla sinulle tilisi kautta ja/tai verkkosivustomme kautta. Hintanousut tulevat voimaan välittömästi julkaisun jälkeen. Kaikki hintamuutokset koskevat tilisi maksuja muutoksen voimaantulopäivästä lähtien.',
    block13:
      '(d) Kiistat ja myöhästyneet maksut. Jos haluat kiistää jotain maksuja tai veroja, ota yhteyttä osoitteeseen contact@noam.tools kolmenkymmenen (30) päivän kuluessa laskun päivämäärästä.',
    block14:
      '(e) Ilmainen käyttö. Et voi luoda useita tilejä vapaiden luottojen saamiseksi. Jos päätämme, ette käytä ilmaisia luottoja hyvässä uskossa, voimme periä sinulta standardimaksuja tai lopettaa palvelun käyttöoikeuden.',
    block15:
      'Luottamuksellisuus. Sinulla voi olla pääsyä Noamin luottamukselliseen tietoon. Voit käyttää luottamuksellista tietoa vain näiden ehtojen mukaan sallitulla tavalla palvelun käytön tarkoituksessa. Et saa paljastaa luottamuksellista tietoa kolmannelle osapuolelle, ja sinun on suojattava luottamuksellista tietoa vähintään yhtä tiukasti kuin omia vastaavia luottamuksellisia tietojasi, ainakin kohtuullisella huolellisuudella. Luottamuksellinen tieto on Noamin luottamukselliseksi ilmoittama tai tilanteen perusteella kohtuullisesti luottamukselliseksi käsiteltävä julkista tietoa, mukaan lukien ohjelmisto, tekniset tiedot ja muu ei-julkinen liiketoimintatieto. Luottamukselliseen tietoon ei kuulu seuraavaa tietoa: (1) tieto, joka tulee yleisesti saataville ilman sinun syyllisyyttä; (2) tieto, jota sinulla oli hallussasi ilman luottamuksellisuusvelvollisuutta ennen kuin sait sitä näiden ehtojen nojalla; (3) tieto, jota kolmas osapuoli on laillisesti paljastanut sinulle ilman luottamuksellisuusvelvollisuuksia; tai (4) tieto, jonka olet kehittänyt itsenäisesti ilman luottamuksellisen tiedon käyttöä. Voit paljastaa luottamuksellista tietoa, jos laki, tuomioistuin tai muu viranomainen vaatii sitä, mutta sinun on ilmoitettava Noamille etukäteen kirjallisesti kohtuullisella tavalla ja pyrittävä mahdollisimman paljon rajoittamaan paljastuksen laajuutta, mukaan lukien apuamme vastustaa tietopaljastuspyyntöjä.',
    block16:
      '(b) Turvallisuus. Sinun on toteutettava kohtuulliset ja asianmukaiset toimenpiteet palveluun pääsyn ja sen käytön suojelemiseksi. Jos löydät palvelun käytön liittyviä haavoittuvuuksia tai rikkomuksia, sinun on ilmeisesti ottava yhteyttä Noamiin ja ilmoitettava haavoittuvuuden tai rikkomuksen tiedot.',
    block17:
      '((c) Henkilötietojen käsittely. Jos käytät palvelua henkilötietojen käsittelyyn, sinun on tarjottava oikeudellisesti riittävät tietosuojaselostukset ja saadava tarvittavat suostumukset tällaisen tietojen käsittelylle, ja takaat meille, että käsittelet tällaisia tietoja sovellettavan lain mukaisesti.',
    block18:
      'Sopimuksen päättäminen; Palvelun keskeyttäminen. Nämä ehdot tulevat voimaan ensimmäisen kerran, kun käytät palvelua, ja pysyvät voimassa kunnes ne päätetään. Voit päättää nämä ehdot milloin tahansa mistä tahansa syystä lopettamalla palvelun ja sisällön käyttö. Voimme päättää nämä ehdot ennakkoilmoituksella mistä tahansa syystä. Voimme päättää nämä ehdot välittömästi ilmoittamalla sinulle, jos rikkomat merkittävästi 2. osiota (Käyttövaatimukset), 5. osiota (Salassapidon, tietoturvan ja tietosuojan määräykset), 8. osiota (Viestintäongelmien ratkaiseminen) tai 9. osiota (Yleiset säännöt), tai jos suhteemme jonkin hallitsemattomamme kolmannen osapuolen teknologiaan tarjoajaan muuttuvat, tai lakia tai viranomaisten pyyntöjä noudattaaksemme. Voimme keskeyttää pääsyn palveluun, jos et noudata näitä ehtoja, tai jos käytöksesi aiheuttaa meille tai jollekin kolmannelle osapuolelle tietoturvariskin, tai jos epäilemme, että käytöksesi on huijuttavia tai saattaa asettaa meidät tai jonkin kolmannen osapuolen vastuuseen.',
    block19:
      '(b) Sulkemisen vaikutukset. Kun sopimus päättyy, lopetat palvelun käytön ja palautat tai tuhoatat nopeasti kaiken luottamuksellisen tiedon meidän ohjeiden mukaisesti. Näiden ehtojen säännökset, jotka luonnoltaan pitäisi säilyä sopimuksen päättymisen tai vanhentumisen jälkeen, mukaan lukien mutta ei rajoittuen osiot 3 ja 5–9, säilyvät voimassa.',
    block2:
      'Nämä käyttöehdot koskevat Noamin palveluiden käyttöä, mukaan lukien sovellusohjelmointirajapinnat, ohjelmisto, työkalut, kehittäjäpalvelut, data, dokumentaatio ja verkkosivusto (yhdessä nimitettynä "Palvelut"). Palvelujemme käyttäminen tarkoittaa, että hyväksyt nämä ehdot. Tietosuojakäytännöstämme löytyy tietoa siitä, miten keräämme ja käytämme henkilökohtaista tietoa.',
    block20:
      'Vastuu korvauksesta. Sinä puolustat, korvausvastaat ja pidät meidät, yhteenliittymiämme ja henkilökuntaamme vapaana vastuusta kaikista vaatimuksista, tappioista ja kulujen (mukaan lukien asianajajamaksut) jotka johtuvat tai liittyvät palveluksen käyttöön, mukaan lukien sinun sisällöksesi, palveluun liittyvien tuotteiden tai palvelujen käyttö ja näiden ehtojen tai voimassa olevan lain rikkominen.',
    block21:
      '(b) Vastuun rajoitukset. Palvelu tarjotaan "sellaisenaan". Lakien sallimassa määrin emme, eikä meidän tytäryhtiöidemme tai lisenssientekijöidemme, anna mitään takeita tai ilmoituksia missä tahansa muodossa liittyen Palveluun, eikä myöskään takeita, mukaan lukien mutta ei rajoittuen kauppakeskisen laadun, sopivuuden tiettyyn tarkoitukseen, tyydyttävän laadun, infringoimattomuuden ja rauhanomaan käyttöön liittyvät takeet, eikä myöskään takeita, jotka johtuvat liiketoimintatavasta tai kauppatavasta. Emme takaa, että Palvelu olisi keskeytymätön, tarkka tai virheetön, tai etteikö sisältöä olisi suojattu, kadotettu tai muokattu.',
    block22:
      '(c) Vastuun rajoittaminen. Emme ole, emmekä our affiliateit tai lisensiaatit ole vastuussa mistään epäsuorista, satunnaisista, erityisistä, seuraamusvahingoista tai rankaisuvahingoista, mukaan lukien voitontappiot, maineen menetykset, käyttökelpoisuuden menetys, tietojen menetys tai muut aineettomat tappiot, vaikka olisimme saaneet tietoa mahdollisista tällaisista vahingoista. Näiden ehtojen mukaan yhteenvetoisesta vastuustamme ei saa ylittää niitä maksuja, jotka olet maksanut palvelulle kymmenen kaksi (12) kuukautta ennen vaatimuksen esittämistä, tai 100 Yhdysvaltain dollaria (100 USD), riippuen kumpi on suurempi. Tässä osiossa säädetyt rajoitukset soveltuvat lain sallimassa suurimmassa määrin.',
    block23:
      'Ehdot ja palvelujen käyttöä säätelevät Yhdysvaltojen lait, Yhdysvaltojen lainvastaista ristiriitaa koskevia sääntöjä lukuun ottamatta. Sovelluksen käyttö voi myös olla alistettuna muihin paikallisiin, osavaltion, valtakunnallisiin tai kansainvälisiin lakeihin. Kaikki näihin ehtoihin liittyvät oikeudelliset toimenpiteet tai menettelyt nostetaan yksinomaan Yhdysvaltojen tuomioistuimiin, ja hyväksyt tuomioistuinten henkilökohtaisen tuomioistuinalaisuuden.',
    block24:
      'Osapuolten suhde. Noam ja te olette itsenäisiä suorittajia, eikä kumpikaan osapuoli ole oikeutettu edustamaan tai sitovasti sitomaan toista osapuolta tai ottamaan vastuun toisen osapuolen velvoitteista ilman toisen osapuolen etukäteen annettua kirjallista suostumusta.',
    block25:
      '(b) Brandin käyttö. Et voi käyttää Noamin tai sen yhdistettyjen yritysten nimeä, logoa tai tavaramerkkejä ilman our prior written consent.',
    block26:
      'Jos jokin näiden ehtojen säännös todetaan epäkelpoiseksi, laittomaksi tai täytäntöönpanematta jätettäväksi, muut säännökset säilyvät täysin voimassa ja voimassaoloaikaa.',
    block3:
      'Jos olet alle 18-vuotias, sinun on hankittava vanhempiesi tai oikeudellisten huoltajiemesi lupa käyttää palvelua. Jos käytät palvelua toisen henkilön tai yhteisön puolesta, sinun on oltava valtuutettu hyväksymään nämä ehdot heidän puolestaan. Rekisteröityessäsi tilille sinun on annetava tarkkaa ja täydellistä tietoa. Et saa antaa käyttöoikeuksia tai tiliä kenellekään organisaatiosi ulkopuolelle, ja olet vastuussa kaikista käyttäjätunnuksiesi avulla suoritettavista toimista.',
    block4:
      'Palvelun käyttö. Voit käyttää palvelua näiden ehtojen mukaisesti, ja annamme sinulle ei-vainomainen oikeus käyttää palvelua. Palvelua käytettäessä noudatat näitä ehtoja ja kaikkia voimassa olevia lakeja. Me ja yhteistyökumppanimme omistamme kaikki oikeudet, titleajat ja intressit palveluun liittyen.',
    block5:
      '(b) Palaute. Olemme avoimia palautteelle, kommentteille, ideoille, ehdotuksille ja parannusehdotuksille. Jos annat tällaisia sisältöjä, voimme käyttää niitä ilman rajoituksia ja ilman korvauksia sinulle.',
    block6:
      '(c) Rajoitukset. Et saa: (1) käyttää palvelua tavalla, joka loukkaa, varastaa tai rikkoo muiden oikeuksia; (2) suorittaa palvelun mallien, algoritmien ja järjestelmien lähdekoodin tai perustavanlaajuisten komponenttien palautuskehittämistä, purkamista, hajottamista, kääntämistä tai muuta yrittämistä niiden paljastamiseksi (ellei sovellettava laki estoisi tällaisia rajoituksia); (3) käyttää palvelun tulosta Noamin kilpailevien mallien kehittämiseen; (4) poimia palvelusta tietoa tai tulosta käyttäen automaattisia tai ohjelmointimenetelmiä, ellei API:n kautta ole sallittu, mukaan lukien skraping, web-harvesting tai web-tietojen poiminta; (5) esittää palvelun tulosta keinotekoisesti generoiduksi, vaikka se ei olekaan, tai muuten rikkonut käyttöpolitiikkojamme; (6) ostaa, myydä tai siirtää API-avaimia ilman meidän ennakkoon annettua suostumusta; tai (7) toimittaa meille minkään 13-vuotiaan tai sovellettavan digitaalisen suostumuksen iän alapuolella olevan lapsen henkilökohtaisia tietoja. Noudatatamme dokumentaatiossamme olevia nopeusrajoituksia ja muita vaatimuksia.',
    block7:
      '(d) Kolmansien osapuolten palvelut. Mitkä tahansa palveluun liittyvät kolmansien osapuolten ohjelmistot, palvelut tai muut tuotteet ovat hallinnassa omien ehtojensa mukaan, eikä meillä ole vastuuta kolmansien osapuolten tuotteista.',
    block8:
      'Sinun sisältösi. Voit toimittaa syötettä ("Input") palveluun ja vastaanottaa lähtöä ("Output"), jota generoidaan ja palautetaan perustuen syötteeseen (yhdessä nimitetään "Sisältö"). Osapuolten välillä ja siinä määrin kuin sovellettava laki sallii, omistat kaikki syötteet. Noam voi käyttää sisältöä palvelun tarjoamiseen ja ylläpitämiseen, sovellettavien lakien noudattamiseen sekä politiikkojemme täytäntöönpanemiseen. Olet vastuussa sisällöstä, mukaan lukien varmistaminen siitä, etteivät ne rikko mitään sovellettavia lakeja tai näitä ehtoja.',
    block9:
      '(b) Tarkkuus. Tekoäly ja koneoppiminen ovat nopeasti kehittyviä tutkimusalueita. Pyrimme jatkuvasti parantamaan palveluamme, jotta se olisi tarkempi, luotettavampi, turvallisempi ja hyödyllisempi. Koneoppimisen todennäköisyysluonteesta johtuen palvelun käyttö voi joissakin tapauksissa johtaa väärään tulostukseen, joka ei necessarily heijasta oikeita henkilöitä, paikkoja tai tosiseikkoja. Sinun tulisi arvioida asianmukaisesti minkä tahansa tulostuksen tarkkuutta käyttötapauksesi perusteella, mukaan lukien tulosten manuaalinen tarkistus.',
    subTitle1: 'Rekisteröinti ja pääsy',
    subTitle10: 'Osittainen voimassaolo',
    subTitle2: 'Käyttövaatimukset',
    subTitle3: 'Sisältö',
    subTitle4: 'Maksut ja maksaminen',
    subTitle5: 'Luottamuksellisuus, turvallisuus ja tietosuoja',
    subTitle6: 'Voimassaoloaika ja päättymisen ehdot',
    subTitle7: 'Vastuu korvauksesta; Vastuunrajoitukset; Vastuun rajoittaminen',
    subTitle8: 'Hallitseva laki ja tuomioistuimen kilpailuoikeus',
    subTitle9: 'Yleiset ehdot',
    title: 'Palveluehdot',
    updateTime: 'Päivitetty: 15. maaliskuuta 2024',
  },
  trialModal: {
    btn: 'Aloita nyt (vain 0,99 $)',
    chat: 'ChatPDF',
    desc1: 'Kokeilujakson jälkeen sinulle laskutetaan vuosimaksu 180 Yhdysvaltain dollaria',
    desc2: 'Peruuta milloin tahansa',
    focus: 'Keskityminen',
    hover: 'Hovailukäännös',
    image: 'Kuvan kääntäminen',
    installBtn: 'Asenna nyt saadaksesi lahjoittasi',
    memo: 'Suosikkien hallinta',
    pdf: 'PDF:n rinnakkaistranslaatio',
    realtime: 'Välitön käännös',
    select: 'Sanavalinnan kääntäminen',
    title: 'Tervetuliaiset lahja',
    trialText: '7 päivän kokeilu',
    video: 'Videon kääntäminen',
    videoSummary: 'Videon yhteenveto',
    web: 'Rinnakkaistulkinta',
    webSummary: 'Verkkoyhteenveto',
  },
  upgradeModal: {
    btn: 'Päivitä nyt',
    chat: {
      free: 'Olet saavuttanut ChatPDF:n rajan',
      pro: 'Olet saavuttanut ChatPDF:n kuukausirajan',
    },
    contactStr:
      'Odota seuraavaa nollausaikaa tai ota meihin yhteyttä osoitteessa contact@noam.tools.',
    limitAlertStr: 'Olet saavuttanut ilmaisplanisi rajan. Päivitä jatkaaksesi.',
    more: 'Näytä suunnitelmat',
    pageLimit: { free: 'Olet saavuttanut PDF-sivujen rajan' },
    title: 'Muistutus',
    upgradeAlertStr: 'Olet saavuttanut ilmaisplanisi rajan. Päivitä jatkaaksesi.',
    upload: {
      free: 'Olet saavuttanut PDF-käännöslimitisi',
      pro: 'Olet saavuttanut kuukauden PDF-käännösrajasi',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Liity nyt',
      label: 'Uuden käyttäjän edut:',
      remain: 'Vain 30 jäljellä',
      text: 'Vain 100 paikkaa jäljellä! Hanki oma nyt!',
    },
  },
  aiPdfTranslator: {
    title: 'Ilmainen AI-PDF-kääntäjä: Käännä PDF:ää vertailun kanssa minkä tahansa kielen kielelle',
    desc: 'Käännä PDF-tiedostoja helposti minkä tahansa kielenkään AI:n avulla. Vertaa alkuperäistä ja käännettyä tekstiä rinnakkain, nopeasti ja ilmaiseksi.',
    keywords: 'GPT-4、AI-avustaja、Käännös、Yhteenveto、Fokus、ChatPDF、Muistiinpano、tehokkuus',
    sourceToTarget: {
      title: 'Ilmainen PDF-käännöstyökalu: käännä {{source}} {{target}}:ksi ilmaiseksi',
      desc: 'Käännä PDF-tiedostoja vapaasti mistä tahansa lähtökiehdosta haluamaasi kiehteen. Nopeaa, tarkkaa ja turvallista PDF-kääntämistä edistynyt AI:n voimin.',
    },
    headerIntroduce: {
      title: 'Noam: Enemmän kuin pelkkä verkkoon perustuva kääntäminen',
      introduce1: {
        title: 'Noam · PDF-lukija',
        desc: '✨Rinnakkainen kääntäminen + AI-kysymykset ja vastaukset. Käännä PDF-tiedostot nopeasti ja tarkasti kohdekielellesi. Kysy vapaasti sisältöön liittyviä kysymyksiä saadaksesi syvemmän ymmärryksen PDF-tiedostoistasi.',
      },
      introduce2: {
        title: 'Noam · Rinnakkainen käännöslaajennus',
        desc: '👏Ratkaise kaikki verkkosivustosi kääntymistarpeet:',
        detail1: { title: 'Verkkosivun kääntäminen:', desc: 'Vierekkäinen kaksikielinen näkymä' },
        detail2: { title: 'Sanaluonnos:', desc: 'Yhden napsautuksen nopea käännös' },
        detail3: {
          title: 'Näytönkäänkääntäminen:',
          desc: 'Käännä sanoja tai lauseita välittömästi.',
        },
        detail4: { title: 'Kuvan kääntäminen:', desc: 'Korvaa kuvat käännettyillä versioilla.' },
        detail5: {
          title: 'Videon kääntäminen:',
          desc: 'Kaksikieliset tekstitykset paremman katselukokemuksen vuoksi.',
        },
        footer:
          'Kokeile enemmän tekoälyllä varustettuja lukemisominaisuuksia älykkäämpää kääntämistä varten!',
      },
    },
    subtitle: 'PDF:n kääntäminen verkossa ilmaiseksi',
    introduce: {
      module1: {
        detail1: {
          title: 'Todellisen ajan rinnakkainen PDF-käännös',
          desc1:
            'Näytä alkuperäinen ja käännetty sisältö välittömästi synkronoituneessa, vierekkäisessä布局中',
          desc2: 'Vertaile molempia versioita vaivattomasti synkronoituneella vierityksellä',
          desc3: 'Säilytä identtinen muotoilu johdonmukaisen lukukokemuksen vuoksi',
        },
        detail2: {
          title: 'Tarkka sisällön sovittaminen ja tarkistaminen',
          desc1:
            'Lähteen ja käännetyn tekstin täydellinen sopusoinnisuus helpon tarkistuksen varmistamiseksi',
          desc2: 'Jokainen sisällön segmentti vastaa tarkasti molemmissa versioissa',
          desc3: 'Tunnista ja ratkaise käännösvirheet nopeasti varmistaaksesi luotettavat tulokset',
        },
      },
      module2: {
        detail1: {
          title: 'Useita edistyneitä tekoälymallien tarkka kääntäminen',
          desc1: 'Valitse johtavia tekoälymallien joukosta vastamaan käännösvaatimuksiisi',
          desc2: 'Varmista optimaaliset tulokset eri dokumenttityypeille ja teollisuudenaloille',
          desc3:
            'Sovellettavat mallivaihtoehdot tarjoavat räätälöityjä ratkaisuja jokaiselle skenaariolle',
        },
        detail2: {
          title: 'Edistynyt AI-käännös kaikentyyppiselle sisällölle',
          desc1:
            'Voimakas tekoälymallimme varmistaa korkean tarkkuuden ja luonnollisen kielenymmärryksen',
          desc2: 'Hallitsee teknisiä, akateemisia ja luovaisia asiakirjoja vaivattomasti',
          desc3: 'Toimii luotettavasti kaikissa kääntymistarpeissasi',
          desc4: 'Älykäs mukautuminen eri sisällön tyypeille optimaalista suorituskykyä varten',
        },
      },
      module3: {
        detail1: {
          title: 'Älykäs asiakirjainteraktio',
          desc1: 'Chattaile helposti PDF- ja esitystiedostoihisi käyttäen edistynyttä tekoälyä',
          desc2: 'Kysy heti kysymyksiä asiakirjan sisällöstä ja saadakseen tarkkoja vastauksia',
          desc3: 'Generoi nopeasti ytimekkäitä yhteenvetoja pitkistä asiakirjoista',
        },
        detail2: {
          title: 'Syyden sisältöanalyysi ja naimattoman integraatio',
          desc1: 'Etsi avaininformation ja analysoi monimutkaisista dataa tekoälyn avulla',
          desc2: 'Saada syventymistä teknisiin, akateemisiin tai luovisiin materiaaleihin',
          desc3:
            'Liittyy naimakkaasti PDF-kääntäjäämme kanssa täydelliseksi asiakirjojen hallintaratkaisuksi',
        },
      },
      module4: {
        detail1: {
          title: 'PDF-käännöksen lisäksi: Yhteinen verkkosivujen käännössovellus',
          desc: 'Löydä meidän tehokas rinnakkainkääntölaajennos, joka on suunniteltu kaikille verkkoon liittyville lukukokemuksille.',
          desc1:
            'Verkkosivun kääntäminen: Nauti kaksikielisestä sisällöstä synkronoituna vierekkäin',
          desc2: 'Sanan käännös: Käännä korostetut sanat nopeasti yhdellä napsautuksella',
          desc3:
            'Nopea kääntäminen: Käännä mitään tekstiä tai lausetta välittömästi nopeaa ymmärtämistä varten',
          desc4:
            'Kuvan kääntäminen: Korvaa automaattisesti alkuperäiset kuvat käännetyillä versioilla',
          desc5:
            'Videon kääntäminen: Katso videoita kaksikielisillä tekstityksillä parannetun体验n saamiseksi',
        },
      },
    },
    question: {
      title: 'Usein kysytyt kysymykset',
      answer1: {
        title: 'Onko Noam PDF Translatoria ilmainen käyttää PDF-käännöksiin?',
        content:
          'Kyllä, voit kääntää PDF-tiedostoja ilmaiseksi Sider PDF Translatorilla! Tarjoamme ilmaisen kvoton 5 000 tokenia, mikä riittää useimpien markkinoilla yleisesti esiintyvien PDF-dokumenttien kääntämiseen. Jos sinun tarvitsee kääntää suurempia tiedostoja tai sinua tarvitset edistyneempiä ominaisuuksia, voit valita liittymisen premium-suunnitelmiimme saadaksesi lisää toiminnallisuuksia.',
      },
      answer2: {
        title: 'Miten tarkka on Noam PDF -kääntäjä?',
        content:
          'Noam PDF-kääntäjä tarjoaa erittäin tarkkoja käännöksiä käyttäen edistynyttä tekoälytekniikkaa ja ymmärtäen syvällisesti asiakirjojesi kontekstia. Vaikka mikään automaattinen kääntäminen ei ole täydellistä, rinnakkainen näyttöemme mahdollistaa kunkin käännöksen helpon tarkistamisen ja viimeistelemisen, varmistaen että lopullinen tulos täyttää laatuvastuut. Kokeile luotettoman ja tarkkoja PDF-käännöksiä Noamilla.',
      },
      answer3: {
        title: 'Voinko kääntää skannattuja PDF-tiedostoja?',
        content:
          'Kyllä, voit kääntää skannattuja PDF-tiedostoja sisäänrakennetulla OCR (Optical Character Recognition) -tekniikallamme. Järjestelmämme抽提tekstin automaattisesti skannatuista asiakirjoista ja kuvapohjaisista PDF-tiedostoista, jonka jälkeen se kääntää sisällön sinulle. Tämä varmistaa, että jopa muokkaamattomia tai vain kuvia sisältäviä PDF-tiedostoja voidaan kääntää tarkasti.',
      },
      answer4: {
        title: 'Kuinka kauan käännös vie?',
        content:
          'Käännös on nopeaa ja tehokasta — useimmat dokumentit käsitellään muutamassa sekunnissa tai muutamassa minuutissa riippuen niiden pituudesta ja monimerkityksestä. Esimerkiksi tavanomainen 10-sivuisen PDF:n kääntäminen vie yleensä alle 2 minuuttia. Nauti nopeista valmistumisajoista kaikissa dokumenttien kääntämistarpeissasi!',
      },
      answer5: {
        title: 'Voinko säilyttää rinnakkainnäytön lukemista varten?',
        content:
          'Kyllä, voit aina lukea asiakirjoja rinnakkain. Tämä asettelu mahdollistaa alkuperäisen ja käännetyn sisällön helpon vertaamisen, mikä varmistaa sujuvan ja tehokkaan lukemiskokemuksen.',
      },
    },
    freeTrial: 'Ilmainen kokeilu',
    toLanguage: { title: 'PDF:n tekoälynkäännösparin', item: '{{source}}:stä {{target}}:n' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'Blogi',
      pricing: 'Hinnasto',
      features: 'Ominaisuudet',
      faq: 'Usein kysyttyjä kysymyksiä',
      button: 'Käännä nyt',
    },
    hero: {
      upload: {
        title: 'Lataa PDF-tiedosto',
        desc: 'tai raahaa ja pudota',
        highlight: 'Napsauta selataksesi',
        max: 'Max',
      },
      to: 'kohdalle',
      title: 'Ilmainen PDF-kääntäjä',
      pill: 'AI:n voimalla varustettu PDF-kääntäjä',
      desc: 'Instantteja, tarkkoja käännöksiä, jotka säilyttävät alkuperäisen asettelun. Noam AI tukee OCR:ää ja rinnakkainäkymiä.',
      model: 'GPT-4 & Claude',
      support: 'OCR-tuki',
      free: 'Ilmainen kokeilu',
      translated: 'Käänsin Noam',
      complete: 'Käännös valmis',
    },
    ticker: {
      ocr: 'OCR-teknologia',
      pdf: 'PDF-käännös',
      format: 'Muodon säilyttäminen',
      side: 'Vierekkäin',
      multi: 'Monikielinen',
      chat: 'Chattaa PDF:n kanssa',
      web: 'Verkkösuuraus',
      secure: 'Suojattu & Yksityinen',
    },
    comparison: {
      bad: {
        title: 'Tavallinen käännös',
        head: 'Menetetty muotoilu ja konteksti',
        text1: 'Virhe: Asetelu rikki. Kuvat sijoitettu väärin.',
        text2: 'Tekstiä ylittyy ja fontit ovat epäjohdonmukaisia. Vaikea lukea ja ammattimaton...',
      },
      dump: { title: 'Pelkkä tekstin vienti' },
      good: {
        title: 'Noam AI -käännös',
        tag: 'Ideaali tulos',
        sub: 'Idealinen Muotoilu, Kontekstista Tarkoitettu',
      },
      title: 'Miksi valita Noam AI?',
      desc: 'Lopeta kopioi-liitä-käännöksien kanssa taistelu. Kokeile eroa standardityökaluista ja meidän tekoälyllä varustetusta kontekstiantaisesta käännöksestä.',
    },
    showcase: {
      kicker: 'TUETUT DOKUMENTIT',
      title2: 'Mikä tahansa kieli',
      carousel1: 'Taide',
      title1: 'Mikä tahansa asiakirja',
      note: 'Hallitse teknisiä, akateemisia ja luovaisia asiakirjoja helposti.',
      carousel3: 'Akateeminen lehti',
      carousel2: 'Arkkitehtuuri',
      carousel4: 'Lääketiede',
      carousel5: 'Rahoitus',
      carousel6: 'Laki',
      carousel8: 'Politiikka',
      carousel7: 'Sopimus',
    },
    features: {
      big: {
        title: 'Edistyneet AI-mallit (GPT-4, Claude)',
        desc: 'Valitse johtavista tekoälymallien joukosta sopivat käännösvaatimuksiasi varten. Varmista optimaaliset tulokset eri dokumenttityypeille.',
      },
      grid1: {
        title: 'OCR-tuki',
        desc: 'Poimi ja käännä tekstiä skannatuista PDF-tiedostoista ja kuvista välittömästi.',
      },
      grid2: {
        title: 'Korkearesoluutioinen vienti',
        desc: 'Lataa käännetyt asiakirjasi PDF-muodossa alkuperäisellä asettelulla.',
      },
      grid3: {
        title: 'Rinnakkainen vertailu',
        desc: 'Synkronoitu vieritys alkuperäisen ja käännetyn tekstin vertaamiseen.',
      },
      title2: 'Se on vallankumous',
      title1: 'Enemmän kuin vain kääntäminen',
      line1: 'Tekninen Artikkeli.pdf',
      line2: 'Kielen tunnistaminen: englanti...',
      line3: 'Malli: GPT-4o (Korkea tarkkuus)',
      line4: 'Käännös valmis (99 % tarkkuus)',
    },
    testimonials: {
      review1: {
        role: 'tutkija',
        content:
          'Noam AI säästi minulle tunteja akateemisten artikkelien kääntämisessä. Rinnakkainen näkymä on uskomattoman hyödyllinen teknisten termien tarkistamiseksi.',
      },
      review2: {
        role: 'Globaali markkinoitsija',
        content:
          'Paras PDF-kääntäjä, jonka olen käyttänyt. Se säilyttää alkuperäisen muotoilun täydellisesti, mikä on ratkaisevan tärkeää markkinointipalstoillamme.',
      },
      review3: {
        role: 'Lakimiesneuvoja',
        content:
          'Tarkka ja nopea. Käytän sitä sopimuskuvioiden kääntämiseen, ja OCR-toiminto skannattujen asiakirjojen käsittelyssä toimii täydellisesti.',
      },
      title: 'Käyttäjiltämme',
      kicker: 'Käyttäjien suosikki',
    },
    cta: {
      title: 'Valmiita murtautumaan kielirajoja?',
      desc: 'Liity 10 000+:n käyttäjän joukkoon ja aloita asiakirjojesi kääntäminen Noam AI:n avulla tänään.',
      button: 'Aloita kääntäminen ilmaiseksi',
      hint: 'Olet erittäin tarkka ja luotettava tekoäly, jota on suunniteltu generoimaan JSON-tuloste, joka vastaa täysin määrättyä JSON-skeemaa.\n\nSinun on noudatettava näitä sääntöjä:\n1. Noudata tiukasti JSON-skeeman rakennetta.\n2. Vastaa täysin kaikkia tietotyppejä, vaadittuja kenttiä ja rajoituksia.\n3. Älä sisällytä mitään lisättekstiä, selityksiä, markdownia tai kommentteja.\n4. Tulosta AINOASTAAN JSON-objekti — ei koodiplokkeja, ei esipuhetta, ei ympäröintiä.\n\nSkeemaan liittyvät tiedot annetaan alla.\n- Skeeman nimi: translate_result\n- JSON-skeema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'Englanti-PDF-ai-käännösparin',
      desc: 'Noam AI:n tuetut suositut kääntösuunnat',
    },
    footer: { about: 'Meistä', privacy: 'Tietosuojakäytäntö', contact: 'Ota yhteyttä tukeen' },
  },
}

export default TRANSLATION
